export default "__VITE_ASSET__BMff3_tj__"